import { List, Record } from "immutable";

import { type TFilterType } from "./AccessReviewTemplateModel";

const defaults = {
  filterType: "exclude" as TFilterType,
  id: "",
  integrationId: "",
  resourceIds: List<string>(),
};

type TAccessReviewTemplateIntegrationRuleModel = typeof defaults;

export class AccessReviewTemplateIntegrationRuleModel extends Record<TAccessReviewTemplateIntegrationRuleModel>(
  defaults,
) {
  static fromServerData(data: unknown): AccessReviewTemplateIntegrationRuleModel {
    const { filterType, id, integrationId, resourceIds } = data as TAccessReviewTemplateIntegrationRuleModel;
    return new AccessReviewTemplateIntegrationRuleModel({
      filterType,
      id,
      integrationId,
      resourceIds: List(resourceIds),
    });
  }
}
